import APIService from '@/services/APIService.js'

export default {
  getNomeEmpresa () {
    return APIService.apiCall().get('/configuracoes/getNomeEmpresa')
  },
  getCsvCamposPadroes () {
    return APIService.apiCall().get('/configuracoes/getCsvCamposPadroes')
  },
  getParamentosJanelaFlagData () {
    return APIService.apiCall().get('/configuracoes/getParamentosJanelaFlagData')
  },
  getModulos () {
    return APIService.apiCall().get('/configuracoes/getModulos')
  },
  saveConfig (id, postData) {
    return APIService.apiCall().post(`/configuracoes/salvar/${id}`, JSON.stringify(postData));
  }
}
